// extracted by mini-css-extract-plugin
export default {"container":"product-plan-allowance_container__pCC6p"};